import { HttpApiService } from "@/shared/services/httpApi.service";

/** The card events the backend can notify; each is also the preference key that switches it on. */
export type CardNotificationEvent =
  | "recharge"
  | "transaction_approved"
  | "transaction_declined"
  | "transaction_reversed"
  | "refund_received"
  | "blocked"
  | "unblocked"
  | "withdrawal"
  | "balance_low";

/** The cards module of the organization's `notification_preferences`. */
export type CardNotificationPreferences = Record<CardNotificationEvent, boolean> & {
  balance_low_threshold_usd: number | null;
};

export interface CardNotificationTestResult {
  sent: boolean;
  /** `skipped` means the messaging service has that notification switched off. */
  status: "sent" | "already_sent" | "skipped" | null;
}

const basePath = (organizationId: string) =>
  `/internal/organizations/${organizationId}/notification-preferences/cards`;

export const cardNotificationsService = {
  get: async (organizationId: string): Promise<CardNotificationPreferences> => {
    const response = await HttpApiService.get<CardNotificationPreferences>(basePath(organizationId));
    return response.data;
  },

  update: async (
    organizationId: string,
    prefs: Partial<CardNotificationPreferences>,
  ): Promise<CardNotificationPreferences> => {
    const response = await HttpApiService.patch<
      CardNotificationPreferences,
      Partial<CardNotificationPreferences>
    >(basePath(organizationId), prefs);
    return response.data;
  },

  sendTest: async (
    organizationId: string,
    event: CardNotificationEvent,
    phone: string,
  ): Promise<CardNotificationTestResult> => {
    const response = await HttpApiService.post<
      CardNotificationTestResult,
      { event: CardNotificationEvent; phone: string }
    >(`${basePath(organizationId)}/test`, { event, phone });
    return response.data;
  },
};
